module.exports = __webpack_public_path__ + "static/abigail-2d6c49e6c386e4ed282bc4918edb0d62.png";